// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section-wrapper-module--wrapper--2vKjJ"};